(function (root) {
  'use strict';
  if (root.DACCartOwnership) return;
  var pending = new Map(), indexes = new WeakMap(), controllers = new Set(), restoring = false;
  var PAGE_SIZE = 20, MAX_PAGES = 40, CONCURRENCY = 4, DEADLINE = 20000;
  function array(value) { return Array.isArray(value) ? value : []; }
  function id(value) { return String(value == null ? '' : value).trim().replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, ''); }
  function normalizeSKU(value) {
    var sku = String(value || '').trim().toUpperCase();
    return /-(AB|DTC|GL)/.test(sku) ? (sku.match(/DAC-\d+[A-Z]?/) || [sku])[0] : sku;
  }
  function manualSKUs(values) {
    var owned = new Set(), removed = new Set();
    array(values).forEach(function (value) {
      if (typeof value !== 'string') return;
      var parts = value.split(':'), sku = normalizeSKU(parts.length === 1 ? value : parts[1]);
      if (!sku) return;
      if (parts[0] === 'MR') removed.add(sku);
      else if (parts.length === 1 || parts[0] === 'MA') owned.add(sku);
    });
    removed.forEach(function (sku) { owned.delete(sku); });
    return owned;
  }
  function excludes(product, history, rawOwnedSKU) {
    history = history || {};
    if (history.authenticated === true && history.complete !== true) return true;
    var index = indexes.get(history);
    if (!index) {
      index = { ids: new Set(array(history.purchasedProductIds).concat(array(history.uncertainRepeat)).map(id)), skus: new Set(array(history.purchasedSKUs).map(normalizeSKU).filter(Boolean)) };
      indexes.set(history, index);
    }
    product = product || {};
    if (Number(product.variantsCount) > 20 || Number(product.variantsCount) > Math.max(array(product.variants).length, array(product.skus).length)) return true;
    if (index.ids.has(id(product.productId || product.product_id || product.id))) return true;
    var skus = [product.sku].concat(array(product.skus), array(product.variants).map(function (v) { return v.sku; })).map(normalizeSKU).filter(Boolean);
    var manual = manualSKUs(rawOwnedSKU);
    return skus.some(function (sku) { return index.skus.has(sku) || manual.has(sku); });
  }
  function empty(authenticated) {
    return { authenticated: authenticated, complete: false, items: [], uncertainRepeat: [], purchasedProductIds: [], purchasedSKUs: [] };
  }
  function load(config) {
    config = config || {};
    var authenticated = config.authenticated === true;
    if (!authenticated) return Promise.resolve(empty(false));
    if (!/^[1-9]\d*$/.test(String(config.theme)) || !config.customerKey || !config.cartUrl || config.historySection !== 'dac-cart-history') return Promise.resolve(empty(true));
    var endpoint;
    try {
      endpoint = new URL(config.cartUrl, root.location.origin);
      if (endpoint.origin !== root.location.origin || !/\/cart\/?$/.test(endpoint.pathname) || (!/\/cart\/?$/.test(root.location.pathname) && !(config.scope === 'product' && /\/products\/[^/]+\/?$/.test(root.location.pathname)))) return Promise.resolve(empty(true));
      var preview = new URL(root.location.href).searchParams;
      ['preview_theme_id', '_fd', 'pb'].forEach(function (name) { if (preview.has(name)) endpoint.searchParams.set(name, preview.get(name)); });
      var activeTheme = root.Shopify && root.Shopify.theme;
      if (activeTheme && String(activeTheme.id) !== String(config.theme)) return Promise.resolve(empty(true));
      if (activeTheme && activeTheme.role === 'unpublished') endpoint.searchParams.set('preview_theme_id', String(config.theme));
      else if (activeTheme && activeTheme.role === 'main') ['preview_theme_id', '_fd', 'pb'].forEach(function (name) { endpoint.searchParams.delete(name); });
      endpoint.searchParams.set('section_id', config.historySection);
    } catch (_) { return Promise.resolve(empty(true)); }
    var cacheKey = [config.theme, config.customerKey, endpoint.href].join('|');
    if (pending.has(cacheKey)) return pending.get(cacheKey);
    var promise = scan();
    pending.set(cacheKey, promise);
    return promise;

    async function scan() {
      var result = empty(true), controller = new AbortController(), started = Date.now();
      var timer = setTimeout(function () { controller.abort(); }, DEADLINE);
      controllers.add(controller);
      var pages = null, totalOrders = null, received = new Set(), purchasedIds = new Set(), purchasedSKUs = new Set(), uncertain = new Set();
      function strings(values) { return Array.isArray(values) && values.length <= 1000 && values.every(function (value) { return typeof value === 'string'; }); }
      async function page(number) {
        if (controller.signal.aborted || Date.now() - started >= DEADLINE) throw new Error('History deadline');
        var url = new URL(endpoint.href); url.searchParams.set('page', String(number));
        var response = await root.fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('History unavailable');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var node = doc.querySelector('[data-dac-cart-history]');
        if (!node) throw new Error('History unavailable');
        var data = JSON.parse(node.textContent);
        if (controller.signal.aborted || Date.now() - started >= DEADLINE || data.authenticated !== true || data.customerKey !== config.customerKey || data.page !== number || data.pageSize !== PAGE_SIZE || data.coverageComplete !== true ||
          !Number.isInteger(data.pages) || data.pages < 0 || data.pages > MAX_PAGES || !Number.isInteger(data.totalOrders) || data.totalOrders < 0 || data.totalOrders > MAX_PAGES * PAGE_SIZE || !(data.pages === Math.ceil(data.totalOrders / PAGE_SIZE) || (data.totalOrders === 0 && data.pages === 1)) ||
          data.scannedOrders !== Math.min(PAGE_SIZE, Math.max(0, data.totalOrders - (number - 1) * PAGE_SIZE)) || data.hasNext !== (number < data.pages) ||
          !strings(data.purchasedProductIds) || !strings(data.purchasedSKUs) || !strings(data.uncertainRepeat) || !Array.isArray(data.items) || data.items.length > 1000 || (number > 1 && data.items.length)) throw new Error('Incomplete history');
        if (pages !== null && (data.pages !== pages || data.totalOrders !== totalOrders)) throw new Error('History changed');
        if (received.has(number)) throw new Error('Duplicate history page');
        if (pages === null) { pages = data.pages; totalOrders = data.totalOrders; }
        received.add(number);
        data.purchasedProductIds.map(id).filter(Boolean).forEach(function (value) { purchasedIds.add(value); });
        data.purchasedSKUs.map(normalizeSKU).filter(Boolean).forEach(function (value) { purchasedSKUs.add(value); });
        data.uncertainRepeat.map(id).filter(Boolean).forEach(function (value) { uncertain.add(value); });
        if (number === 1) result.items = data.items;
      }
      try {
        await page(1);
        for (var start = 2; start <= pages; start += CONCURRENCY) {
          var batch = [];
          for (var current = start; current <= pages && current < start + CONCURRENCY; current++) batch.push(page(current));
          var outcomes = await Promise.allSettled(batch);
          if (outcomes.some(function (outcome) { return outcome.status !== 'fulfilled'; })) throw new Error('Incomplete history');
        }
        result.complete = !controller.signal.aborted && Date.now() - started < DEADLINE && received.size === Math.max(1, pages);
      } catch (_) {
        controller.abort();
      } finally {
        clearTimeout(timer); controllers.delete(controller);
      }
      result.purchasedProductIds = Array.from(purchasedIds);
      result.purchasedSKUs = Array.from(purchasedSKUs);
      result.uncertainRepeat = Array.from(uncertain);
      return result;
    }
  }
  root.addEventListener('pagehide', function () {
    controllers.forEach(function (controller) { controller.abort(); });
    root.document.querySelectorAll('[data-dac-cart-recs], [data-cart-recommendations]').forEach(function (element) { element.hidden = true; });
  });
  root.addEventListener('pageshow', function (event) {
    if (event.persisted && !restoring && root.document.querySelectorAll('[data-dac-cart-recs], [data-cart-recommendations]').length) { restoring = true; root.location.reload(); }
  });
  root.DACCartOwnership = Object.freeze({ load: load, excludes: excludes, normalizeSKU: normalizeSKU });
}(window));
